{
  "CSAT": {
    "TITLE": "Оцініть ваш діалог",
    "PLACEHOLDER": "Розкажіть нам більше...",
    "RATINGS": {
      "POOR": "😞 Погано",
      "FAIR": "😑 Слабо",
      "AVERAGE": "😐 Посередньо",
      "GOOD": "😀 Добре",
      "EXCELLENT": "😍 Відмінно"
    }
  }
}
